import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/main.scss';
import ImgProfile from 'contents/assets/img/@profile.png';
import PopRecommend from './_PopRecommend';
import Calendar from '../../component/Inc/Calendar';
import Tab from '../../component/Inc/Tab';
function MonthlyBestTeacher() {
  const navigate = useNavigate();
  const [modalRecommend, setModalRecommend] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '우선 선정', value: 1},
    {title: '추천 선정', value: 2}
  ];
  return (
    <main className="com_container p_monthly">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu0_2">이달의 우수교사</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalRecommend(true)} className="com_btn orange s btn_plus">
              우수 교사 추천
            </button>
            <button onClick={() => navigate('/MonthlyBestTeacher/Manage')} className="com_btn orange s btn_settings">
              우수 교사 관리
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <Calendar />
            <div className="com_head_conts">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="gray" />
              <strong className="title">2023년 3월 이달의 우수교사</strong>
            </div>
            <div className="com_card_list">
              {[1, 2, 3, 5].map((i, idx) => {
                return (
                  <div className="card_item" key={idx}>
                    <div className="item_top center">
                      <div className="info">
                        <button className="btn_heart active">16</button>
                        <div className="com_btn_wrap">
                          <button className="btn_edit"></button>
                        </div>
                      </div>
                    </div>
                    <div className="item_mid">
                      <div className="info_area">
                        <p className="thumb">
                          <img src={ImgProfile} alt="profile" />
                        </p>
                        <div className="info_box">
                          <span className="com_icon line blue">우선 선정</span>
                          <p className="name">홍길동103</p>
                          <p className="desc">영어</p>
                          <p className="incentive">포인트 24P</p>
                        </div>
                      </div>
                    </div>
                    <div className="item_bt">
                      <p className="txt">22년 총 수업 700타임 이상 유지율 100%를 달성하셨습니다. 현재 핵심 역량 교사 양성 교관으로 선정되셔서 준비중에 있고, 수업뿐만 아니라 회사 활동에도 적극적으로 참여해주시고 계십니다. 올해 더 많은 활동이 기대가 되는 교사입니다. 이에 12월 기라성으로 추천드립니다.</p>
                    </div>
                  </div>
                );
              })}
              <div className="card_item">
                <div className="item_top center">
                  <div className="info">
                    <button className="btn_heart active">16</button>
                    <div className="com_btn_wrap">
                      <button className="btn_edit"></button>
                    </div>
                  </div>
                </div>
                <div className="item_mid">
                  <div className="info_area">
                    <p className="thumb">
                      <img src={ImgProfile} alt="profile" />
                    </p>
                    <div className="info_box">
                      <span className="com_icon line green">추천 선정</span>
                      <p className="name">홍길동103</p>
                      <p className="desc">영어</p>
                    </div>
                  </div>
                </div>
                <div className="item_bt">
                  <p className="txt">22년 총 수업 700타임 이상 유지율 100%를 달성하셨습니다. 현재 핵심 역량 교사 양성 교관으로 선정되셔서 준비중에 있고, 수업뿐만 아니라 회사 활동에도 적극적으로 참여해주시고 계십니다. 올해 더 많은 활동이 기대가 되는 교사입니다. 이에 12월 기라성으로 추천드립니다. 더 길어질 경우는 어떻게??</p>
                </div>
              </div>
            </div>
            <hr className="com_divider" />
            <section className="com_tit_wrap">
              <h2 className="com_pg_tit icon_mail_open">이달의 기라성으로 추천받으신 선생님들은 카카오 모바일 교환권을 발송해 드릴 예정입니다. 축하드립니다.</h2>
            </section>
            <div className="com_comment_wrap type_box">
              <ul className="comment_list">
                {[1, 2, 3, 4, 5].map((i, idx) => {
                  return (
                    <li className="item" key={idx}>
                      <div className="info">
                        <p className="name">홍길동104</p>
                        <span className="dot" />
                        <p className="date">2023.05.20 11:30</p>
                      </div>
                      <p className="txt">
                        22년 총 수업 700타임 이상 유지율 100%를 달성하셨습니다. <br />
                        축하드려요~!
                      </p>
                    </li>
                  );
                })}
                <li className="item">
                  <div className="info">
                    <p className="name">홍길동104</p>
                    <span className="dot" />
                    <p className="date">2023.05.20 11:30</p>
                    <div className="com_btn_wrap">
                      <button className="btn_edit"></button>
                      <button className="btn_delete"></button>
                    </div>
                  </div>
                  <p className="txt">
                    축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!축하드려요~!
                    <br />
                    축하드려요~!
                  </p>
                </li>
              </ul>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
                <button className="com_btn gray l">댓글 등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopRecommend open={modalRecommend} close={() => setModalRecommend(false)} />
    </main>
  );
}

export default MonthlyBestTeacher;
